<template>
  <div>
    <v-stepper v-model="$route.params.step">
      <v-stepper-header>
        <v-stepper-step :complete="$route.params.step > 1" step="1">
          {{ $t("settings.tariff.selectPackage") }}
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="$route.params.step > 2" step="2">
          {{ $t("settings.tariff.selectPaymentMethod") }}
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="3">
          {{ $t("settings.tariff.summary") }}
        </v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step step="4">
          {{ $t("settings.tariff.completion") }}
        </v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <planSelect />
          <v-row class="pb-10">
            <div class="flex-grow-1"></div>
            <v-btn color="primary" @click="increaseTab">
              {{ $t("settings.tariff.continue") }}
            </v-btn>

            <v-btn text @click="decreaseTab"> {{ $t("general.back") }} </v-btn>
          </v-row>
        </v-stepper-content>

        <v-stepper-content step="2">
          <paymentData />
          <v-row class="pb-6">
            <div class="flex-grow-1"></div>
            <v-btn color="primary" @click="increaseTab">
              {{ $t("settings.tariff.continue") }}
            </v-btn>

            <v-btn text @click="decreaseTab"> {{ $t("general.back") }} </v-btn>
          </v-row>
        </v-stepper-content>

        <v-stepper-content step="3">
          <v-row>
            <div class="flex-grow-1"></div>
            <v-btn color="primary" @click="increaseTab">
              {{ $t("settings.tariff.continue") }}
            </v-btn>

            <v-btn text @click="decreaseTab"> {{ $t("general.back") }} </v-btn>
          </v-row>
        </v-stepper-content>
        <v-stepper-content step="4">
          {{ $t("settings.tariff.finish") }}
          <v-row>
            <div class="flex-grow-1"></div>
            <v-btn color="primary" @click="increaseTab">
              {{ $t("settings.tariff.continue") }}
            </v-btn>

            <v-btn text @click="decreaseTab"> {{ $t("general.back") }} </v-btn>
          </v-row>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import paymentData from "./paymentData.vue";
import planSelect from "./planSelect.vue";
export default {
  name: "customerDataForm",
  components: { paymentData, planSelect },
  data: () => ({
    portalData: null,
    order: null,
  }),
  mounted() {
    console.log(JSON.parse(this.$route.params.portalData));
  },
  methods: {
    closeform() {
      this.data.open = false;
      this.resetData();
    },
    resetData() {
      //reset whole form data
      this.portalData = null;
      //reset form component form only after contact create
      if (this.data.method === "new") {
        this.$refs.formComponent.resetForm();
      }
    },
    decreaseTab() {
      this.$router.push({
        name: "changePlan",
        params: {
          portalData: this.$route.params.portalData,
          step: Number(this.$route.params.step) - 1,
          selected: {},
        },
      });
    },
    increaseTab() {
      //increase Tab
      this.$router.push({
        name: "changePlan",
        params: {
          portalData: this.$route.params.portalData,
          step: Number(this.$route.params.step) + 1,
          selected: {},
        },
      });
    },
  },
};
</script>
